import {useContext} from "react";
import ErrorContext from "../context/ErrorContext";

export const useErrorContext = () => useContext(ErrorContext)